// Unwraps an axios response body into a plain object regardless of whether
// it came from the legacy AWS Lambda API Gateway integration (which wraps
// the payload as { statusCode, body: "<json>" }) or the current Express
// service (which returns the payload directly at the root).
export const parseApiResponse = (response) => {
  if (!response?.data) return null;
  const body = response.data.body;
  if (body === undefined) return response.data;
  if (typeof body === 'string') {
    try {
      return JSON.parse(body);
    } catch {
      return null;
    }
  }
  return body;
};

export default parseApiResponse;
